const PROJECT_FOLLOWUP_BASE = '/project-followup';

const STATUS_TAB_ROUTE_MAP: Record<number, string> = {
  5: `${PROJECT_FOLLOWUP_BASE}?tab=4`,
  6: `${PROJECT_FOLLOWUP_BASE}?tab=2`,
  7: `${PROJECT_FOLLOWUP_BASE}?tab=3`,
  10: `${PROJECT_FOLLOWUP_BASE}?tab=1`,
  4: `${PROJECT_FOLLOWUP_BASE}?tab=5`,
};

const appendSearchToProjectFollowUp = (route: string, proposalNumber: string): string => {
  const separator = route.includes('?') ? '&' : '?';
  return `${route}${separator}search=${encodeURIComponent(proposalNumber)}`;
};

export const getProposalFollowUpLink = (
  proposalNumber?: string,
  statusId?: number | null,
): string | undefined => {
  if (!proposalNumber) return undefined;
  if (typeof statusId !== 'number') return undefined;

  const route = STATUS_TAB_ROUTE_MAP[statusId];
  if (!route) return undefined;

  return appendSearchToProjectFollowUp(route, proposalNumber);
};
